import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeletePersonalTreatmentPlanTemplateMutation } from "@/modules/admin/treatment/services/__generated__/useDeletePersonalTreatmentPlanTemplateMutation.graphql"

const mutation = graphql`
  mutation useDeletePersonalTreatmentPlanTemplateMutation($input: DeletePersonalTreatmentPlanTemplateInput!) {
    deletePersonalTreatmentPlanTemplate(input: $input) {
      treatmentPlanTemplate {
        name
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeletePersonalTreatmentPlanTemplateMutationHook = () => {
  const [commit] = useMutationWithErrorDialog<useDeletePersonalTreatmentPlanTemplateMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeletePersonalTreatmentPlanTemplateMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler] as const
}

export { useDeletePersonalTreatmentPlanTemplateMutationHook }
